import * as React from "react";
const SvgFiRrRocketLunch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rocket-lunch_svg__a)">
      <path
        fill="#062147"
        d="M1.879 17.878a11.3 11.3 0 0 0-1.835 4 1.74 1.74 0 0 0 2.083 2.082 11.3 11.3 0 0 0 3.994-1.834 3.002 3.002 0 0 0-4.242-4.248m2.828 2.83c-.806.516-1.682.914-2.6 1.183a10.1 10.1 0 0 1 1.184-2.6 1 1 0 0 1 1.414 1.414zM18 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M20.97 0A15.49 15.49 0 0 0 8.635 6.006a11.1 11.1 0 0 0-4.57 1.163 8.1 8.1 0 0 0-3.821 3.666 2.96 2.96 0 0 0 .25 2.8A3.01 3.01 0 0 0 3.013 15H5.5A3.517 3.517 0 0 1 9 18.5v2.486a3.01 3.01 0 0 0 1.363 2.521 2.96 2.96 0 0 0 2.8.25 8.1 8.1 0 0 0 3.665-3.822 11.1 11.1 0 0 0 1.163-4.569A15.5 15.5 0 0 0 24 3a3.01 3.01 0 0 0-3.029-3M4.346 13H3.014a1 1 0 0 1-.85-.46.95.95 0 0 1-.085-.91 6.18 6.18 0 0 1 2.883-2.673 9 9 0 0 1 1.993-.72A34.4 34.4 0 0 0 4.345 13m10.7 6.038a6.18 6.18 0 0 1-2.671 2.883.95.95 0 0 1-.912-.085 1 1 0 0 1-.46-.85v-1.332a34.4 34.4 0 0 0 4.762-2.609 9 9 0 0 1-.723 1.993zm.135-4.02a30 30 0 0 1-4.271 2.471 5.5 5.5 0 0 0-4.4-4.4 30 30 0 0 1 2.472-4.267C12.35 4.124 15.84 2.147 21 2a1 1 0 0 1 1 .972c-.148 5.188-2.125 8.678-6.822 12.046z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rocket-lunch_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRocketLunch;
